export class PurchaseRequest{
    vendorId:number
    invoiceNumber:string
    purchaseId:number
    plantId:number
    productsInfo:PurchaseProductsInfo[]
    isActive: boolean;
    createdAt : Date ;
    createdUser : string;
    updatedAt : Date ;
    updatedUser : string;
    versionFlag : number;
    
    constructor(
    vendorId:number,
    invoiceNumber:string,
    purchaseId:number,
    plantId:number,
    productsInfo:PurchaseProductsInfo[],
    isActive: boolean,
    createdAt : Date ,
    createdUser : string,
    updatedAt : Date ,
    updatedUser : string,
    versionFlag : number,

    ){
        this.vendorId = vendorId
        this.invoiceNumber = invoiceNumber
        this.plantId = plantId
        this.purchaseId = purchaseId
        this.productsInfo = productsInfo
        this.isActive = isActive
        this.createdAt = createdAt
        this.createdUser = createdUser
        this.updatedAt = updatedAt 
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
    }
}

export class PurchaseProductsInfo{
    purchaseProductId : number
      unitPrice:number
    cases:number
    totalAmount:number
    taxId : number
    // purchaseId : number
    netWeight:number
    caseWeight : number
    packStyleId :number
    productId :number
    // isActive: boolean;
    createdAt : Date ;
    createdUser : string;
    updatedAt : Date ;
    updatedUser : string;
    versionFlag : number;
    productName?: string
    packStyle?:string
    tax?:string
    constructor(
        unitPrice:number,
        cases:number,
        totalAmount:number,
        taxId : number,
        // purchaseId : number,
        netWeight:number,
        caseWeight : number,
        packStyleId :number,
        productId :number,
        // isActive: boolean,
        createdAt : Date ,
        createdUser : string,
        updatedAt : Date ,
        updatedUser : string,
        versionFlag : number,
    purchaseProductId : number,
    productName?: string,
    packStyle?:string,
    tax?:string,

    ){
        this.caseWeight = caseWeight
        this.cases = cases
        this.netWeight = netWeight
        this.packStyleId = packStyleId
        this.productId = productId
        // this.purchaseId = purchaseId
        this.taxId = taxId
        this.totalAmount = totalAmount
        this.unitPrice = unitPrice
        // this.isActive = isActive
        this.createdAt = createdAt
        this.createdUser = createdUser
        this.updatedAt = updatedAt 
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.purchaseProductId = purchaseProductId
        this.productName = productName
        this.packStyle = packStyle
        this.tax = tax
    }
}